import {debounceTime} from 'rxjs/operators';
import {Component, OnInit, Output, EventEmitter, Input} from '@angular/core';
import {WizardWidgetComponent} from '../wizard-widget/wizard-widget.component';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ValidationPartialComponent } from '../partials/validation-partial.component';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import {
  CarSearchComponent
} from '../../../../../firstmac-material-lib/projects/fmc-elements/src/lib/car-search/car-search.component';

@Component({
    selector: 'app-auto-collateral',
    templateUrl: './auto-collateral.component.html',
    styles: [],
    standalone: true,
    imports: [MatCardModule, CarSearchComponent, MatCardModule, FormsModule, ReactiveFormsModule, MatFormFieldModule,
      MatFormFieldModule, MatInputModule, MatInputModule, ValidationPartialComponent]
})

export class AutoCollateralComponent extends WizardWidgetComponent implements OnInit {
  @Input() public formGroup: UntypedFormGroup;
  @Output() public autoCollateralChange = new EventEmitter<any>();

  ngOnInit() {
    super.ngOnInit();

    this.formGroup.valueChanges.pipe(
      debounceTime(500))
      .subscribe(val => {
        console.debug('AutoCollateralComponent.valueChanges');
        if (val && val.vehicle.id) {
          this.autoCollateralChange.emit(val.vehicle);
        }
      });
  }
}
